import { map as _map } from 'lodash';

export default class SearchService {
  constructor($http, $q, authService, appConfig) {
    "ngInject";

    this.$http = $http;
    this.$q = $q;
    this.appConfig = appConfig;
    this.authService = authService;
  }

  buildSearchQuery(filterParams){
    let query = '';

    query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
    query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
    query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
    query += `&ascending=${filterParams.pageCriteria.ascending}`;

    query += `&searchTerm=${filterParams.searchTerm}`;

    return query;
  }

  searchEnquiriesByReg(filterParams) {
    const entityIds = _map(this.authService.authData.userLocations, o => o.key);
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/search/enquiries' + this.buildSearchQuery(filterParams), entityIds);
  }

  searchContacts(filterParams) {
    const entityIds = _map(this.authService.authData.userLocations, o => o.key);
    return this.$http.post(this.appConfig.apiServiceBaseUri + 'api/search/contacts' + this.buildSearchQuery(filterParams), entityIds);
  }  
}



// WEBPACK FOOTER //
// ./client/app/components/omniSearch/search.service.js